import storage from 'local-storage-fallback';

const STORAGE_USER = 'user';
const COOKIE_AUTH = 'auth';

let user;

export const getUser = () => {
  if (user) {
    return user;
  }

  try {
    // Prima prova a recuperare il token dai cookie
    const cookies = document.cookie.split(';');
    let authToken = null;

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(`${COOKIE_AUTH}=`)) {
        authToken = cookie.substring(`${COOKIE_AUTH}=`.length, cookie.length);
        break;
      }
    }

    // Se il token è stato trovato nei cookie, lo decodifica e lo restituisce
    if (authToken) {
      // Assumiamo che il token sia un JWT, quindi possiamo decodificare la parte payload
      const payload = authToken.split('.')[1];
      if (payload) {
        const decodedPayload = JSON.parse(atob(payload));

        // Verifica la scadenza del token
        if (decodedPayload.exp * 1000 <= new Date()) {
          throw 'JWT token scaduto.';
        }

        user = decodedPayload;
        user.token = authToken;

        return user;
      }
    }

    // Fallback: prova a recuperare dal localStorage
    user = JSON.parse(storage.getItem(STORAGE_USER));

    if (!user) return;

    if (user.exp * 1000 <= new Date()) {
      throw 'JWT token scaduto.';
    }

    return user;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    logOut();
  }
};

export const saveUser = (obj) => storage.setItem(STORAGE_USER, JSON.stringify(obj));
export const saveToken = (token, expiration) => {
  // Rileva automaticamente il dominio
  const {hostname} = window.location;
  const domain = hostname === 'localhost' ? 'localhost' : hostname.split('.').slice(-2).join('.');

  // Calcola la data di scadenza in formato UTC
  const expirationDate = new Date(expiration * 1000).toUTCString();

  // Imposta il cookie con il dominio rilevato e la scadenza
  document.cookie = `${COOKIE_AUTH}=${token}; path=/; domain=${domain}; expires=${expirationDate}; secure; samesite=strict`;
};

export const logOut = () => {
  user = null;
  storage.removeItem(STORAGE_USER);
  window.location.href = '/login';
};
